const tiles = document.querySelectorAll('.js-tile-link');

const init = function() {
  if ( tiles.length ) {
    tiles.forEach( tile => {
      const href = tile.getElementsByTagName('a')[0].getAttribute('href');
      if ( href ) {
        tile.classList.add('has-hover');
        tile.addEventListener( 'click', () => {
          window.location = href;
        } )
      }
    } );
  }
};

const api = {
	init: init
};

export default api;